export enum MESSAGE_MEDIUMS {
  SMS = 'SMS',
  WEB_PUSH = 'WebPush',
  IN_APP = 'InApp',
  PUSH = 'Push',
  EMAIL = 'Email',
}

export type EmailChannel = {
  id: number;
  createdAt: number;
  updatedAt: number;
  name: string;
  channelType: string;
  projectId: number;
  creatorUserId: string;
  espBindings?: EspBinding[];
  messageMedium: MESSAGE_MEDIUMS;
};

export type EspBinding = {
  espAccountId: number;
  trafficPercentage: number;
};
